export default "__VITE_ASSET__DTca2yoM__"